export const isPath = (p0, p1) => getCleanPath(p0) === getCleanPath(p1)

export const isPathChild = (parent, child) => getCleanPath(child).startsWith(getCleanPath(parent))

export const getCleanPath = path => (path === `/` ? path : path.replace(/\/$/, ``).replace(/^\//, ``))
